// Single source of truth for per-route titles and descriptions.
// Used by the <Seo> component at runtime and by scripts/prerender.mjs at
// build time so AI crawlers (which don't run JS) see the same head content.
export interface PageMeta {
  path: string;
  title: string;
  description: string;
}

export const pageMeta: Record<string, PageMeta> = {
  home: {
    path: "/",
    title: "Private Driver & LAX Airport Transfer in Los Angeles | GOOD RIDES LA",
    description:
      "Book a premium private chauffeur in Los Angeles. 24/7 LAX airport transfers, hotel rides, event transportation & private city tours. Licensed, insured, 4.9-rated. Instant WhatsApp booking.",
  },
  services: {
    path: "/services",
    title: "Chauffeur Services in Los Angeles: LAX Transfer, Tours, Events | GOOD RIDES LA",
    description:
      "Private chauffeur services in Los Angeles: LAX & Burbank airport transfers, hotel rides, wedding & event transportation, nightlife service, and custom city tours. Book 24/7.",
  },
  tours: {
    path: "/tours",
    title: "Private LA City Tours: Hollywood, Venice, Beverly Hills | GOOD RIDES LA",
    description:
      "Private Los Angeles city tours with a local driver-guide. Hollywood Sign, Griffith Observatory, Santa Monica, Venice Beach, Beverly Hills & more. Custom itineraries, hotel pickup included.",
  },
  faq: {
    path: "/faq",
    title: "FAQ: Private Driver & LAX Transfer Questions | GOOD RIDES LA",
    description:
      "Answers about our Los Angeles private driver service: how LAX airport pickup works, booking lead times, service areas, payment options, child seats, and custom tour planning.",
  },
  contact: {
    path: "/contact",
    title: "Contact Us: Book a Private Driver in Los Angeles | GOOD RIDES LA",
    description:
      "Contact GOOD RIDES LA: call +1 (310) 926-5298, WhatsApp for instant worldwide booking, or email. 24/7 private driver and LAX airport transfer service in Los Angeles.",
  },
};
